import React, { useState, useEffect } from 'react';
import { useApi } from '../../../hooks/useApi';
import logger from "../../../utils/logger";
import EntityCell from '../EntityCell';
function AdminPublicProfiles() {
  const {
    request,
    showStatus
  } = useApi();
  const [profiles, setProfiles] = useState([]);
  const [loading, setLoading] = useState(false);
  // Раньше грузились все публичные профили платформы одним запросом.
  const PAGE_SIZE = 200;
  const [page, setPage] = useState(0);
  const [hasMore, setHasMore] = useState(false);
  useEffect(() => {
    loadProfiles();
    // eslint-disable-next-line
  }, [page]);
  const loadProfiles = async () => {
    setLoading(true);
    try {
      const data = await request(`/api/v1/admin/public-profiles?skip=${page * PAGE_SIZE}&limit=${PAGE_SIZE}`);
      const rows = data || [];
      setProfiles(rows);
      setHasMore(rows.length === PAGE_SIZE);
    } catch (error) {
      logger.error('Failed to load profiles', error);
    } finally {
      setLoading(false);
    }
  };
  const handleModerate = async (userId, field, value) => {
    try {
      await request(`/api/v1/admin/public-profiles/${userId}`, {
        method: 'PATCH',
        body: JSON.stringify({
          [field]: value
        })
      });
      showStatus('success', 'Обновлено');
      loadProfiles();
    } catch (error) {
      showStatus('error', 'Ошибка обновления');
    }
  };
  return <div className="admin-page">
            <div style={{
      marginBottom: '30px'
    }}>
                <h1>Публичные профили (Модерация)</h1>
                <p style={{
        color: '#666'
      }}>Агентства, активировавшие публичную страницу</p>
            </div>

            <div style={{
      background: 'white',
      borderRadius: '12px',
      boxShadow: '0 4px 6px rgba(0,0,0,0.05)',
      overflow: 'hidden'
    }}>
                <table style={{
        width: '100%',
        borderCollapse: 'collapse'
      }}>
                    <thead style={{
          background: '#f8f9fa',
          borderBottom: '2px solid #eee'
        }}>
                        <tr>
                            <th style={{
              padding: '15px',
              textAlign: 'left'
            }}>Агентство / Владелец</th>
                            <th style={{
              padding: '15px',
              textAlign: 'left'
            }}>Ссылка (Slug)</th>
                            <th style={{
              padding: '15px',
              textAlign: 'center'
            }}>Статус</th>
                            <th style={{
              padding: '15px',
              textAlign: 'center'
            }}>Бейджи</th>
                            <th style={{
              padding: '15px',
              textAlign: 'right'
            }}>Действия</th>
                        </tr>
                    </thead>
                    <tbody>
                        {loading && <tr><td colSpan="5" style={{
              padding: '40px',
              textAlign: 'center'
            }}>Загрузка...</td></tr>}
                        {!loading && profiles.length === 0 && <tr><td colSpan="5" style={{
              padding: '40px',
              textAlign: 'center'
            }}>Нет публичных профилей</td></tr>}
                        {profiles.map(p => <tr key={p.id} style={{
            borderBottom: '1px solid #f5f5f5'
          }}>
                                <td style={{
              padding: '15px'
            }}>
                                    <EntityCell name={p.full_name} owner={p.email} id={p.id} />
                                </td>
                                <td style={{
              padding: '15px'
            }}>
                                    <a href={`/user/${p.slug}`} target="_blank" rel="noreferrer" style={{
                color: '#3498db',
                textDecoration: 'none',
                fontSize: '13px'
              }}>
                                        /user/{p.slug} ↗
                                    </a>
                                </td>
                                <td style={{
              padding: '15px',
              textAlign: 'center'
            }}>
                                    <span style={{
                fontSize: '12px',
                color: '#27ae60',
                fontWeight: 'bold'
              }}>AКТИВЕН</span>
                                </td>
                                <td style={{
              padding: '15px',
              textAlign: 'center'
            }}>
                                    <div style={{
                display: 'flex',
                justifyContent: 'center',
                gap: '8px'
              }}>
                                        <button onClick={() => handleModerate(p.id, 'verified_identity', !p.is_verified)} style={{
                  border: 'none',
                  background: p.is_verified ? '#e3f2fd' : '#f5f5f5',
                  color: p.is_verified ? '#3498db' : '#999',
                  padding: '4px 8px',
                  borderRadius: '4px',
                  cursor: 'pointer',
                  fontSize: '12px'
                }} title="Подтвержденная личность">
                    
                                            {p.is_verified ? '✅ Verified' : 'Verify'}
                                        </button>
                                        <button onClick={() => handleModerate(p.id, 'anylex_recommended', !p.is_recommended)} style={{
                  border: 'none',
                  background: p.is_recommended ? '#fff9db' : '#f5f5f5',
                  color: p.is_recommended ? '#f1c40f' : '#999',
                  padding: '4px 8px',
                  borderRadius: '4px',
                  cursor: 'pointer',
                  fontSize: '12px'
                }} title="Рекомендовано Энилекс">
                    
                                            {p.is_recommended ? '⭐️ Best' : 'Recommend'}
                                        </button>
                                    </div>
                                </td>
                                <td style={{
              padding: '15px',
              textAlign: 'right'
            }}>
                                    <button onClick={() => {
                if (window.confirm('Выключить публичный профиль?')) {
                  handleModerate(p.id, 'public_enabled', false);
                }
              }} style={{
                background: 'none',
                border: 'none',
                color: '#e74c3c',
                cursor: 'pointer',
                fontSize: '13px',
                fontWeight: 'bold'
              }}>
                  
                                        Деактивировать
                                    </button>
                                </td>
                            </tr>)}
                    </tbody>
                </table>
            </div>
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 15, marginTop: 15 }}>
                <button onClick={() => setPage((p) => Math.max(0, p - 1))} disabled={page === 0 || loading} style={{ padding: '8px 16px' }}>← Назад</button>
                <span style={{ color: '#666', fontSize: 14 }}>Страница {page + 1}</span>
                <button onClick={() => setPage((p) => p + 1)} disabled={!hasMore || loading} style={{ padding: '8px 16px' }}>Вперёд →</button>
            </div>
        </div>;
}
export default AdminPublicProfiles;
